var newsList = {
	noResults: "Keine Ergebnisse gefunden",
	readMore: "Mehr",
	estimatedReadingTime: "~{minutes} Minuten zu lesen"
};
var de = {
	newsList: newsList
};

export { de as default, newsList };
